import PageHeader from 'lib/designSystem/PageHeader';
import ProcessDialog from 'lib/designSystem/ProcessDialog';
import React from 'react';

import PayoutInvoices from './components/Invoices';

const NewPayOut = (props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  setSuccessOpen: (success: string) => void;
  setFailureOpen: (failure: string) => void;
  setUp: () => Promise<void>;
}) => {
  const { setOpen, open, setSuccessOpen, setFailureOpen, setUp } = props;

  return (
    <ProcessDialog.Simple
      open={open}
      onClose={() => setOpen(false)}
      title={
        <PageHeader.TitleSection
          title="Registro de pago a proveedores"
          iconType="payment"
          iconVariant="outlined"
        />
      }
      contentVariant="spacious"
    >
      <PayoutInvoices
        setSuccessOpen={setSuccessOpen}
        setFailureOpen={setFailureOpen}
        setUp={setUp}
        setOpen={setOpen}
      />
    </ProcessDialog.Simple>
  );
};

export default NewPayOut;
